module.exports = __webpack_public_path__ + "static/media/reading-level.675d2f28.png";